/**
 * @generated SignedSource<<792fff3328784a1bda4d01d6856a13a8>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type RegisterUserInput = {|
  access_key?: ?string,
  clientMutationId?: ?string,
  first_name: string,
  last_name: string,
  validated_email_token: string,
|};
export type AuthContextRegisterUserMutation$variables = {|
  input: RegisterUserInput,
|};
export type AuthContextRegisterUserMutation$data = {|
  +register_user: {|
    +user: {|
      +__typename: "AccessKeyConsumed",
      +message: string,
    |} | {|
      +__typename: "AccessKeyRequired",
      +message: string,
    |} | {|
      +__typename: "EmailDomainNotAllowed",
      +allowed_domains: $ReadOnlyArray<string>,
      +domain: string,
    |} | {|
      +__typename: "InactiveAccessKey",
      +message: string,
    |} | {|
      +__typename: "InvalidAccessKey",
      +message: string,
    |} | {|
      +__typename: "UserLimitReached",
      +message: string,
    |} | {|
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      +__typename: "%other",
    |},
  |},
|};
export type AuthContextRegisterUserMutation = {|
  response: AuthContextRegisterUserMutation$data,
  variables: AuthContextRegisterUserMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RegisterUserPayload",
    "kind": "LinkedField",
    "name": "register_user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "InactiveAccessKey",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "InvalidAccessKey",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "AccessKeyConsumed",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "AccessKeyRequired",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "UserLimitReached",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowed_domains",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "domain",
                "storageKey": null
              }
            ],
            "type": "EmailDomainNotAllowed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthContextRegisterUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthContextRegisterUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f808568ee14bbfb71494c360f3fec2e8",
    "id": null,
    "metadata": {},
    "name": "AuthContextRegisterUserMutation",
    "operationKind": "mutation",
    "text": "mutation AuthContextRegisterUserMutation(\n  $input: RegisterUserInput!\n) {\n  register_user(input: $input) {\n    user {\n      __typename\n      ... on InactiveAccessKey {\n        message\n      }\n      ... on InvalidAccessKey {\n        message\n      }\n      ... on AccessKeyConsumed {\n        message\n      }\n      ... on AccessKeyRequired {\n        message\n      }\n      ... on UserLimitReached {\n        message\n      }\n      ... on EmailDomainNotAllowed {\n        allowed_domains\n        domain\n      }\n    }\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "51d365976e46da514f4871a07db28e06";

module.exports = ((node/*: any*/)/*: Mutation<
  AuthContextRegisterUserMutation$variables,
  AuthContextRegisterUserMutation$data,
>*/);
